var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"subtitle"},[(_vm.hasProperty)?_c('span',[_vm._v("\n        Thank you for your interest in \""+_vm._s(_vm.property.strShortAddress)+"\".\n        "),_c('br')]):_vm._e(),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }